import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-data-void',
  imports: [],
  templateUrl: './data-void.component.html',
  styleUrl: './data-void.component.scss'
})
export class DataVoidComponent {
  @Input() titulo: string = 'Título padrão';
  @Input() descricao: string = 'Descrição padrão';
}
